export const COPY_SUCCESS = "Password copiado exitosamente"
export const COPY_Fail = "No se pudo copiar el Password"